export default "__VITE_ASSET__BLeSdr5C__"